import { validateRulesForRedirectToMF } from '@/utils/mfNav/rulesRedirectToMF';

const guard = async (to, from, next) => {
  const route = to.name;
  const routeMF = process.env.CHECKIN_MF_ROUTE_REDIRECT;
  const isRedirectToMF = await validateRulesForRedirectToMF(route);

  if (routeMF && isRedirectToMF) {
    console.log(
      `Init Redirect: route=${route}, routeMF=${routeMF}, isRedirectToMF=${isRedirectToMF}`,
    );
    window.location.replace(routeMF);
  }
  next();
};

export default guard;
